import React from 'react';
import { AnalyticsPeriod, ResolvedPeriod } from '../../../features/analytics/PeriodPicker';
import { QualityKpiCards } from '../../../features/analytics/quality/QualityKpiCards';
import { TopBuggyComponents } from '../../../features/analytics/quality/TopBuggyComponents';
import { TopBuggyLabels } from '../../../features/analytics/quality/TopBuggyLabels';
import { BugTypeBreakdown } from '../../../features/analytics/quality/BugTypeBreakdown';
import { SprintReleaseSnapshot } from '../../../features/analytics/quality/SprintReleaseSnapshot';
import { FlakyStoriesTable } from '../../../features/analytics/quality/FlakyStoriesTable';
import { DynamicsSection } from '../../../features/analytics/quality/dynamics/DynamicsSection';
import { RiskHeatmap } from '../../../features/analytics/quality/RiskHeatmap';
import { EscapeRootCauseTable } from '../../../features/analytics/quality/EscapeRootCauseTable';
import { QualityOnboardingBanner } from '../../../features/analytics/quality/QualityOnboardingBanner';

interface QualityTabProps {
  period: AnalyticsPeriod | null;
  resolvedPeriod: ResolvedPeriod | null;
}

export const QualityTab: React.FC<QualityTabProps> = ({ period, resolvedPeriod }) => {
  return (
    <div className="quality-tab" id="quality-tab">
      <QualityOnboardingBanner />
      <div id="quality-kpis">
        <QualityKpiCards period={period} resolvedPeriod={resolvedPeriod} />
      </div>
      <div id="dynamics-section">
        <DynamicsSection period={period} resolvedPeriod={resolvedPeriod} />
      </div>
      <div id="risk-heatmap">
        <RiskHeatmap resolvedPeriod={resolvedPeriod} />
      </div>
      <div className="quality-breakdown-grid">
        <TopBuggyComponents resolvedPeriod={resolvedPeriod} />
        <TopBuggyLabels resolvedPeriod={resolvedPeriod} />
      </div>
      <div id="bug-type-breakdown">
        <BugTypeBreakdown resolvedPeriod={resolvedPeriod} />
      </div>
      <div id="escape-root-cause">
        <EscapeRootCauseTable resolvedPeriod={resolvedPeriod} />
      </div>
      <SprintReleaseSnapshot period={period} resolvedPeriod={resolvedPeriod} />
      <FlakyStoriesTable resolvedPeriod={resolvedPeriod} />
    </div>
  );
};

export default QualityTab;
